import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

export default function ListItemSys({text, icon, openHeader, moduleActive}) {

    return (
        <ListItem
            key={text}
            disablePadding
            sx={{ display: "block", color: moduleActive == text  && openHeader ? "white" : "#2B3A8B", background: moduleActive == text && openHeader ? "#2c4992" : "transparent" }}
        >
            <ListItemButton
                sx={{
                    minHeight: 48,
                    justifyContent: openHeader ? "initial" : "center",
                    px: 2.5,
                }}
            >
                <ListItemIcon
                    sx={{
                        minWidth: 0,
                        mr: openHeader ? 3 : "auto",
                        justifyContent: "center",
                    }}
                >
                    {icon}
                </ListItemIcon>
                <ListItemText
                    primary={text}
                    sx={{ opacity: openHeader ? 1 : 0 }}
                />
            </ListItemButton>
        </ListItem>
    )
}